module.exports = __webpack_public_path__ + "img/logo-icon.75c2f721.png";